// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"d5b46871","139":"7e217da7","179":"15734580","203":"0aa7a25d","282":"324063c9","378":"68525634","617":"67b8313b","637":"867e6eb0","671":"64e0065d","947":"c7aa4b7d"}[chunkId] + ".chunk.js";
};